import api from "./api";

const ProjectService = {
  //get projects of an organization
  getProjectsByOrganization(orgId) {
    return api.get(`/api/v1/organization/${orgId}/projects`);
  },

  //  create project under organization
  createProject(orgId, project) {
    return api.post(`/api/v1/organization/${orgId}/projects`, project);
  },

  //  get single project (SAFE)
  getProjectById(orgId, projectId) {
    return api.get(`/api/v1/organization/${orgId}/projects/${projectId}`);
  },

  getallProject(orgId) {
    return api.get(`/api/v1/organization/${orgId}/projects/all`)
  },

  //  update project
  updateProject(orgId, projectId, project) {
  return api.put(
    `/api/v1/organization/${orgId}/projects/${projectId}`,
    project
  );
},

  //  delete project
  deleteProject(orgId, projectId) {
    return api.delete(`/api/v1/organization/${orgId}/projects/${projectId}`);
  },
};

export default ProjectService;
